module.exports = __webpack_public_path__ + "01c73fa1ea1c9b5fa61f5f374922e3ed.jpg";